/* eslint-disable no-console */
import { inject, Injectable, Injector } from '@angular/core';
import { isProd, toCssSimple } from 'src/app/core/helpers/utils';

export const styledLog = (
  data: { msg: string; params?: unknown; dom?: unknown },
  styles: { [key: string]: string } = { 'background-color': 'green', color: 'white' }
) => {
  if (!isProd) {
    if (data.params === undefined && data.dom === undefined) {
      console.log(`%c@${data.msg}`, toCssSimple(styles), data.params);
    } else if (data.params !== undefined && data.dom === undefined) {
      console.log(`%c@${data.msg}  params:%O`, toCssSimple(styles), data.params);
    } else if (data.params === undefined && data.dom !== undefined) {
      console.log(`%c@${data.msg}\nDom:%o`, toCssSimple(styles), data.dom);
    } else if (data.params !== undefined && data.dom !== undefined) {
      console.log(`%c@${data.msg}  params:%O\nDom:%o`, toCssSimple(styles), data.params, data.dom);
    }
  }
};
export const log = <T extends unknown[]>(...args: T): void => {
  if (!isProd) {
    console.log(...args);
  }
};
export const formattedStringify = (data: unknown, space = 2): string => {
  try {
    return JSON.stringify(data, null, space);
  } catch (error) {
    console.error('@formattedStringify: Failed to stringify data', error);
    return '';
  }
};

@Injectable()
export class Logger {
  private injector = inject(Injector);

  public log(...data: unknown[]) {
    if (!isProd) {
      if (data.length === 1) {
        console.log(data[0]);
      } else if (data.length === 2) {
        console.log(data[0], data[1]);
      } else {
        for (const item of data) {
          console.log(item);
        }
      }
    }
  }
  public error<T extends unknown[]>(...args: T): void {
    console.error(...args);
    try {
      /* Currently not supported on agency
      const tracker = this.injector.get(ErrorTracker);
      tracker.trackError(...args); */
    } catch (error) {
      // just in case
      console.error('@Logger.error: Failed to track error', error);
    }
  }
  public warn<T extends unknown[]>(...args: T): void {
    console.warn(...args);
  }
}
